const italianNameCollator = new Intl.Collator('it', {
  sensitivity: 'base',
  numeric: true,
})

export const normalizePersonSearch = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('it-IT')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()

export const personLabel = (person = {}) =>
  [person.nome, person.cognome]
    .map(part => String(part || '').trim())
    .filter(Boolean)
    .join(' ')

export const buildPersonOptions = (people = []) =>
  (Array.isArray(people) ? people : [])
    .map(person => {
      const label = personLabel(person)
      return {
        value: person.id,
        label,
        searchText: normalizePersonSearch(label),
      }
    })
    .filter(option => option.value !== null && option.value !== undefined && option.label)
    .sort((a, b) => italianNameCollator.compare(a.label, b.label))

export const personOptionMatches = (option, inputValue = '') => {
  const queryTokens = normalizePersonSearch(inputValue).split(' ').filter(Boolean)
  if (queryTokens.length === 0) return true

  const candidate = option?.data?.searchText
    || option?.searchText
    || normalizePersonSearch(option?.label)

  return queryTokens.every(token => candidate.includes(token))
}

export const filterPersonOptions = (options, inputValue = '') =>
  (Array.isArray(options) ? options : []).filter(option =>
    personOptionMatches(option, inputValue)
  )

export const personMatchesSearch = (person, inputValue = '') =>
  personOptionMatches({
    label: personLabel(person),
    searchText: normalizePersonSearch(personLabel(person)),
  }, inputValue)

export const sortPeopleByName = (people = []) =>
  [...(Array.isArray(people) ? people : [])]
    .sort((a, b) => italianNameCollator.compare(personLabel(a), personLabel(b)))
